import { atom } from "jotai";

export const chestsAtom = atom([]);
export const chestAtom = atom({});
export const errorsAtom = atom({});
export const isLoadingAtom = atom(false);
export const openedChestId = atom(null);
